import liqpayLogo from "@/assets/img/svg/liqpay.svg";
import otpBankLogo from "@/assets/img/svg/otp-bank.svg";

export const DeliveryType = {
  PICKUP: "pickup",
  STORAGE: "storage",
  ADDRESS: "address",
  COURIER: "courier",
};

export const PaymentProcessType = {
  CARD_ONLINE: "card_online",
  PAY_WITH_DETAILS: "pay_with_details",
  ELECTRONIC: "electronic",
  INSTALLMENT: "installment",
};

export const PaymentLogo = {
  card: { src: liqpayLogo, alt: "LiqPay" },
  card_liqpay: { src: liqpayLogo, alt: "LiqPay" },
  card_otp: { src: otpBankLogo, alt: "ОТП Банк" },
  installment_otp: { src: otpBankLogo, alt: "ОТП Банк" },
};

export const RecipientType = {
  ME: 0,
  ANOTHER: 1,
};

export const OrderType = {
  TRANSFER: "transfer",
  CLIENTSALE: "clientsale",
  SALE: "sale",
};
